<template>
  <div>
    <div style="padding-left: 30px;">
      <p style="font-size: 30px;"><b>Quick Access</b></p>
    </div>
    <div class="card" dir="rtl" style="padding: 30px;">
      <table class="full_width">
        <tr>
          <th>EXPLAINATION</th>
          <th>Button</th>
        </tr>
        <tbody>
          <tr>
            <td>
              מסדר את כל האופרס לפי הצבע הסגול (מגדול לקטן)
            </td>
            <td>
              <a class="button is-danger"># ➞</a>
            </td>
          </tr>
          <tr>
            <td>
              מראה את כל המספרים של כל דגלי גאנה בעמוד
            </td>
            <td>
              <a class="button is-info">#</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'quick-access'
}
</script>
<style scoped>
  td {
    padding-top: 30px;
  }
</style>
